import React, { useState, useEffect } from 'react';
import '../../styles/ai-testcase-generator.css';
import axios from 'axios'; 
import axiosInstance from '../../api/axiosInstance';
// import {toast} from 'react-toastify'; // Commented out - using react-toast now
import { toast } from 'react-toast';
import { TestCasesModal } from './Modals';
import DeleteConfirmationModal from '../test-plans/DeleteConfirmationModal';
const API_BASE_URL = process.env.REACT_APP_BASE_URL;


const AutomatedTestScenarioGenerator = ({ item, itemType, onClose, onSave, onNavigateToTestSuite, generatedScenarios: propScenarios,  projectId, caseGenerated: propCaseGenerated  }) => {
  const [generatedScenarios, setGeneratedScenarios] = useState(propScenarios || []);
  const [isGenerating, setIsGenerating] = useState(!propScenarios || propScenarios.length === 0);
  const [generationComplete, setGenerationComplete] = useState(propScenarios && propScenarios.length > 0);
  const [selectedScenarios, setSelectedScenarios] = useState([]);
  const [openScenarioId, setOpenScenarioId] = useState(null); // single-open collapsible
  const [savingStatus, setSavingStatus] = useState(null);
  const [editingScenario, setEditingScenario] = useState(null);
  const [editedContent, setEditedContent] = useState('');
  const [analysisResults, setAnalysisResults] = useState(null);
  const [testSuites, setTestSuites] = useState([]);
  const [testPlans, setTestPlans] = useState([]);
  const [showTestPlanView, setShowTestPlanView] = useState(false);
  const [activeTestStrategy, setActiveTestStrategy] = useState('both'); // 'manual', 'automated', or 'both'
const [generatedTestCases, setGeneratedTestCases] = useState(null);
const [showTestCasesModal, setShowTestCasesModal] = useState(false);
const [generatingTestCases, setGeneratingTestCases] = useState(false);
const [actualItemType, setActualItemType] = useState(itemType);
  const [caseGenerated, setCaseGenerated] = useState(propCaseGenerated || false);
  const [editingScenarioId, setEditingScenarioId] = useState(null);
const [editedScenarios, setEditedScenarios] = useState({});
const [savingScenarioId, setSavingScenarioId] = useState(null);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [scenarioToDelete, setScenarioToDelete] = useState(null);
const [isDeletingScenario, setIsDeletingScenario] = useState(false);

  // Generate test scenarios when component mounts
  // useEffect(() => {
  //   generateTestScenarios();
  // }, []);
  useEffect(() => {
   if (item.epicId || item.epicKey) {
    setActualItemType('story');
  } else {
    setActualItemType('epic');
  }
  console.log(actualItemType, "actualitemtype")
}, [item]);
    useEffect(() => {
    if (generatedScenarios.length > 0) {
      setSelectedScenarios(generatedScenarios.map(s => s.id));
    }
  }, [generatedScenarios]);

    // Ensure the first scenario is opened by default when scenarios are provided (covers propScenarios and generation)
    useEffect(() => {
      if (generatedScenarios && generatedScenarios.length > 0) {
        // if nothing is open yet, open the first scenario
        setOpenScenarioId(prev => (prev === null ? generatedScenarios[0].id : prev));
      } else {
        setOpenScenarioId(null);
      }
    }, [generatedScenarios]);
const analyzeEpicContent = (epic) => {
 
  const content = epic.description || '';
  const title = epic.summary || '';
  
  return {
   
    bddPatterns: extractBDDPatterns(content),
    happyPaths: identifyHappyPaths(content, title),
    edgeCases: identifyEdgeCases(content, title),
    hasExplicitBDD: extractBDDPatterns(content).length > 0,
    type: 'epic'
  };
};

const analyzeStoryContent = (story) => {

  const content = story.description || '';
  const title = story.summary || '';
  
  return {
 
    bddPatterns: extractBDDPatterns(content),
    happyPaths: identifyHappyPaths(content, title),
    edgeCases: identifyEdgeCases(content, title),
    hasExplicitBDD: extractBDDPatterns(content).length > 0,
    type: 'story',
    epicContext: story.epicKey || story.epicId
  };
};
const generateEpicScenariosFromAnalysis = (analysis, epic) => {

  const scenarios = [];

  return scenarios;
};


const generateStoryScenariosFromAnalysis = (analysis, story) => {

  const scenarios = [];
 
  return scenarios;
};
  // Function to generate test scenarios using AI
  const generateTestScenarios = () => {
  if (propScenarios && propScenarios.length > 0) {
      setGeneratedScenarios(propScenarios);
      setIsGenerating(false);
      setGenerationComplete(true);
      setSelectedScenarios(propScenarios.map(s => s.id));
      return;
    }
    

    

    // Simulate AI test scenario generation with a delay
    setTimeout(() => {
      // Analyze the item to extract BDD syntax and identify scenarios
    const analysis = actualItemType === 'epic' 
    ? analyzeEpicContent(item) 
    : analyzeStoryContent(item);
  
  setAnalysisResults(analysis);
      
      // Generate scenarios based on the analysis
     const scenarios = actualItemType === 'epic'
    ? generateEpicScenariosFromAnalysis(analysis, item)
    : generateStoryScenariosFromAnalysis(analysis, item);
  
  setGeneratedScenarios(scenarios);
      // Open the first scenario by default after generation (if any)
      if (scenarios && scenarios.length > 0) {
        setOpenScenarioId(scenarios[0].id);
      } else {
        setOpenScenarioId(null);
      }
      
      // Generate test suites based on the scenarios
      const suites = generateTestSuites(scenarios);
      setTestSuites(suites);
      
      // Generate test plans based on the test suites
      const plans = generateTestPlans(suites, item, itemType);
      setTestPlans(plans);
      
      setIsGenerating(true);
      setGenerationComplete(true);
      // Select all scenarios by default
      setSelectedScenarios(scenarios.map(s => s.id));
    }, 2000);
  };
const handleGenerateTestCases = async () => {
  try {
    setGeneratingTestCases(true);
    
    const authDataString = localStorage.getItem('user');
    if (!authDataString) {
      throw new Error('User not authenticated');
    }
    
    const authData = JSON.parse(authDataString);
    const accessToken = authData.accessToken;
    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const config = {
      headers: {
        'token': accessToken,
        'Content-Type': 'application/json'
      }
    };

    const storyId = item.dbId || item.id;
    
    if (!storyId || isNaN(storyId)) {
      throw new Error('Valid story ID not found. Please sync stories first.');
    }

    // Build request payload with selected scenarios
    const payload = {
      project_id: projectId,
      story_id: storyId,
      scenarios_id: selectedScenarios
    };

    const response = await axios.post(
      `${API_BASE_URL}/test_case/scenario/story`,
      payload,
      config
    );

    if (response.status === 200) {
      setGeneratedTestCases(response.data);
      setShowTestCasesModal(true);
        setCaseGenerated(true);
      toast.success('Test cases generated successfully!');
    } else {
      toast.error('Failed to generate test cases');
    }
  } catch (error) {
    console.error('Error generating test cases:', error);
    if (error.response) {
      toast.error(`Failed to generate test cases: ${error.response.data?.detail || error.response.statusText}`);
    } else if (error.request) {
      toast.error('Failed to generate test cases: No response from server');
    } else {
      toast.error(`Failed to generate test cases: ${error.message}`);
    }
  } finally {
    setGeneratingTestCases(false);
  }
};
  // Analyze item content to extract BDD syntax and identify scenarios
  const analyzeItemContent = (item, itemType) => {
    const content = item.description || '';
    const title = item.summary || '';
    
    // Extract Given-When-Then patterns if present
    const bddPatterns = extractBDDPatterns(content);
    
    // Identify potential happy paths
    const happyPaths = identifyHappyPaths(content, title);
    
    // Identify potential edge cases
    const edgeCases = identifyEdgeCases(content, title);
    
    return {
      bddPatterns,
      happyPaths,
      edgeCases,
      hasExplicitBDD: bddPatterns.length > 0
    };
  };

  // Extract Given-When-Then patterns from content
  const extractBDDPatterns = (content) => {
    const patterns = [];
    
    // Look for Given-When-Then patterns in the content
    const givenRegex = /Given\s+(.*?)(?=\s+When|\s+Then|$)/gis;
    const whenRegex = /When\s+(.*?)(?=\s+Then|$)/gis;
    const thenRegex = /Then\s+(.*?)(?=\s+Given|$)/gis;
    
    // Extract all "Given" statements
    let givenMatch;
    while ((givenMatch = givenRegex.exec(content)) !== null) {
      const givenText = givenMatch[1].trim();
      
      // Find corresponding "When" statement
      whenRegex.lastIndex = givenMatch.index + givenMatch[0].length;
      const whenMatch = whenRegex.exec(content);
      
      if (whenMatch) {
        const whenText = whenMatch[1].trim();
        
        // Find corresponding "Then" statement
        thenRegex.lastIndex = whenMatch.index + whenMatch[0].length;
        const thenMatch = thenRegex.exec(content);
        
        if (thenMatch) {
          const thenText = thenMatch[1].trim();
          
          patterns.push({
            given: givenText,
            when: whenText,
            then: thenText
          });
        }
      }
    }
    
    return patterns;
  };

  // Identify potential happy paths from content
  const identifyHappyPaths = (content, title) => {
    const happyPaths = [];
    
    // Keywords that might indicate a happy path
    const happyPathKeywords = [
      'successfully', 'complete', 'valid', 'normal', 'standard', 'typical',
      'expected', 'primary', 'main flow', 'happy path'
    ];
    
    // Check if any happy path keywords are in the content
    const contentLower = content.toLowerCase();
    const titleLower = title.toLowerCase();
    
    // Simple heuristic: if the content contains happy path keywords, extract sentences containing them
    happyPathKeywords.forEach(keyword => {
      if (contentLower.includes(keyword)) {
        // Extract sentences containing the keyword
        const sentences = content.split(/[.!?]+/).filter(s => s.toLowerCase().includes(keyword));
        sentences.forEach(sentence => {
          happyPaths.push({
            description: sentence.trim(),
            keyword: keyword
          });
        });
      }
    });
    
    // If no explicit happy paths found, infer from title
    if (happyPaths.length === 0) {
      happyPaths.push({
        description: `User should be able to ${titleLower}`,
        inferred: true
      });
    }
    
    return happyPaths;
  };

  // Identify potential edge cases from content
  const identifyEdgeCases = (content, title) => {
    const edgeCases = [];
    
    // Keywords that might indicate edge cases
    const edgeCaseKeywords = [
      'error', 'exception', 'fail', 'invalid', 'boundary', 'limit',
      'maximum', 'minimum', 'edge case', 'corner case', 'negative',
      'timeout', 'overflow', 'underflow', 'unexpected'
    ];
    
    // Check if any edge case keywords are in the content
    const contentLower = content.toLowerCase();
    
    // Extract sentences containing edge case keywords
    edgeCaseKeywords.forEach(keyword => {
      if (contentLower.includes(keyword)) {
        // Extract sentences containing the keyword
        const sentences = content.split(/[.!?]+/).filter(s => s.toLowerCase().includes(keyword));
        sentences.forEach(sentence => {
          edgeCases.push({
            description: sentence.trim(),
            keyword: keyword
          });
        });
      }
    });
    
    // Generate common edge cases if none found
    if (edgeCases.length === 0) {
      edgeCases.push({
        description: `System should handle invalid input when attempting to ${title.toLowerCase()}`,
        inferred: true
      });
      edgeCases.push({
        description: `System should handle timeout scenarios when ${title.toLowerCase()}`,
        inferred: true
      });
    }
    
    return edgeCases;
  };

const handleViewTestCases = async () => {
  try {
    setGeneratingTestCases(true);
    
    const authDataString = localStorage.getItem('user');
    if (!authDataString) {
      throw new Error('User not authenticated');
    }
    
    const authData = JSON.parse(authDataString);
    const accessToken = authData.accessToken;
    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const config = {
      headers: {
        'token': accessToken,
        'Content-Type': 'application/json'
      }
    };


    const storyId = item.dbId || item.id;
    
    if (!storyId || isNaN(storyId)) {
      throw new Error('Valid story ID not found');
    }


    // const response = await axios.get(
    //   `${API_BASE_URL}/test_case/cases_list?project_id=${projectId}&jira_story_id=${storyId}&page=1&page_size=100`,
    //   config
    // );
    const response = await axiosInstance.get(
      `/test_case/cases_list?project_id=${projectId}&jira_story_id=${storyId}&page=1&page_size=100`
    
    );

    if (response.status === 200 || response.status == "success") {
      setGeneratedTestCases(response);
      setShowTestCasesModal(true);
    } else {
      toast.error('Failed to fetch test cases');
    }
  } catch (error) {
    console.error('Error fetching test cases:', error);
    if (error.response) {
      toast.error(`Failed to fetch test cases: ${error.response.data?.detail || error.response.statusText}`);
    } else if (error.request) {
      toast.error('Failed to fetch test cases: No response from server');
    } else {
      toast.error(`Failed to fetch test cases: ${error.message}`);
    }
  } finally {
    setGeneratingTestCases(false);
  }
};
const requestDeleteScenario = (scenarioId) => {
  const scenario = generatedScenarios.find((s) => s.id === scenarioId);
  setScenarioToDelete(scenario || { id: scenarioId });
  setShowDeleteConfirm(true);
};

const cancelDeleteScenario = () => {
  setShowDeleteConfirm(false);
  setScenarioToDelete(null);
};

const confirmDeleteScenario = async () => {
  if (!scenarioToDelete) return;

  const scenarioId = scenarioToDelete.id;

  setIsDeletingScenario(true);
  try {
    const authDataString = localStorage.getItem('user');
    if (!authDataString) {
      throw new Error('User not authenticated');
    }

    const authData = JSON.parse(authDataString);
    const accessToken = authData.accessToken;
    if (!accessToken) {
      throw new Error('Access token not found');
    }

    const config = {
      headers: {
        'token': accessToken,
        'Content-Type': 'application/json'
      }
    };

    const response = await axios.delete(
      `${API_BASE_URL}/scenario/?scenario_id=${scenarioId}`,
      config
    );

    if (response.status === 200) {
      setGeneratedScenarios((prev) => prev.filter((scenario) => scenario.id !== scenarioId));
      setSelectedScenarios((prev) => prev.filter((id) => id !== scenarioId));
      toast.success('Scenario deleted successfully!');
      cancelDeleteScenario();
    } else {
      toast.error('Failed to delete scenario');
    }
  } catch (error) {
    console.error('Error deleting scenario:', error);
    if (error.response) {
      toast.error(`Failed to delete scenario: ${error.response.data?.detail || error.response.statusText}`);
    } else if (error.request) {
      toast.error('Failed to delete scenario: No response from server');
    } else {
      toast.error(`Failed to delete scenario: ${error.message}`);
    }
  } finally {
    setIsDeletingScenario(false);
  }
};
  // Generate scenarios from analysis
  const generateScenariosFromAnalysis = (analysis, item, itemType) => {
    const scenarios = [];
    let scenarioId = 1;
    
    // If BDD patterns were found, convert them directly to scenarios
    if (analysis.bddPatterns.length > 0) {
      analysis.bddPatterns.forEach((pattern, index) => {
        const title = `Scenario ${index + 1}: ${pattern.given.substring(0, 50)}...`;
        const riskImpact = calculateRiskImpact(pattern.given, pattern.when, pattern.then);
        
        scenarios.push({
          id: scenarioId++,
          title: title,
          description: `BDD scenario extracted from ${itemType} description`,
          type: 'bdd',
          preconditions: [`System is available`, `User has appropriate permissions`],
          steps: [
            { type: 'given', text: pattern.given },
            { type: 'when', text: pattern.when },
            { type: 'then', text: pattern.then }
          ],
          expectedResult: `The system should respond as described: ${pattern.then}`,
          priority: assignPriorityBasedOnRisk(riskImpact),
          riskImpact: riskImpact,
          estimatedTime: "30 minutes",
          source: "Extracted from BDD syntax",
          parameterizedSuggestions: generateParameterizedSuggestions(pattern.given, pattern.when)
        });
      });
    }
    
    // Generate happy path scenarios
    analysis.happyPaths.forEach((path, index) => {
    
      const steps = generateStepsFromPath(path.description, 'happy_path');
      const title = `Happy Path ${index + 1}: ${path.description.substring(0, 50)}...`;
      const riskImpact = calculateRiskImpact(steps[0].text, steps[1].text, steps[2].text, 'happy_path');
      
      const scenario = {
        id: scenarioId++,
        title: title,
        description: path.description,
        type: 'happy_path',
        preconditions: generatePreconditions(path.description, 'happy_path'),
        steps: steps,
        expectedResult: `The operation completes successfully and the user sees confirmation`,
        priority: assignPriorityBasedOnRisk(riskImpact),
        riskImpact: riskImpact,
        estimatedTime: "45 minutes",
        source: path.inferred ? "Inferred from title" : "Extracted from description",
        parameterizedSuggestions: generateParameterizedSuggestions(steps[0].text, steps[1].text)
      };
      
      scenarios.push(scenario);
    });
    
    // Generate edge case scenarios
    analysis.edgeCases.forEach((edgeCase, index) => {
      // Convert edge case to Given-When-Then format
      const steps = generateStepsFromPath(edgeCase.description, 'edge_case');
      const title = `Edge Case ${index + 1}: ${edgeCase.description.substring(0, 50)}...`;
      const riskImpact = calculateRiskImpact(steps[0].text, steps[1].text, steps[2].text, 'edge_case');
      
      const scenario = {
        id: scenarioId++,
        title: title,
        description: edgeCase.description,
        type: 'edge_case',
        preconditions: generatePreconditions(edgeCase.description, 'edge_case'),
        steps: steps,
        expectedResult: `The system should handle the exception gracefully and display an appropriate error message`,
        priority: assignPriorityBasedOnRisk(riskImpact),
        riskImpact: riskImpact,
        estimatedTime: "60 minutes",
        source: edgeCase.inferred ? "Common edge case pattern" : "Extracted from description",
        parameterizedSuggestions: generateParameterizedSuggestions(steps[0].text, steps[1].text, true)
      };
      
      scenarios.push(scenario);
    });
    
    return scenarios;
  };

  // Generate Given-When-Then steps from a path description
  const generateStepsFromPath = (description, type) => {
    // For happy paths
    if (type === 'happy_path') {
      return [
        { 
          type: 'given', 
          text: `The user has access to the ${description.toLowerCase().includes('page') ? description.match(/(\w+)\s+page/i)?.[1] || 'feature' : 'feature'} page` 
        },
        { 
          type: 'when', 
          text: description 
        },
        { 
          type: 'then', 
          text: `The operation completes successfully and the user sees confirmation` 
        }
      ];
    }
    
    // For edge cases
    if (type === 'edge_case') {
      return [
        { 
          type: 'given', 
          text: `The system is in a state where ${description.toLowerCase()}` 
        },
        { 
          type: 'when', 
          text: `The user attempts to perform the action` 
        },
        { 
          type: 'then', 
          text: `The system should handle the exception gracefully and display an appropriate error message` 
        }
      ];
    }
    
    // Default case
    return [
      { type: 'given', text: 'Given a precondition' },
      { type: 'when', text: 'When an action occurs' },
      { type: 'then', text: 'Then an expected outcome happens' }
    ];
  };
  
  // Calculate risk and impact score based on scenario content
  const calculateRiskImpact = (given, when, then, type = 'bdd') => {
    let riskScore = 0;
    let impactScore = 0;
    
    // Risk factors - keywords that indicate higher risk
    const riskKeywords = [
      'authentication', 'authorization', 'payment', 'security', 'critical',
      'data loss', 'privacy', 'sensitive', 'financial', 'compliance',
      'legal', 'regulatory', 'mandatory', 'error', 'exception', 'fail'
    ];
    
    // Impact factors - keywords that indicate higher impact
    const impactKeywords = [
      'all users', 'customer', 'revenue', 'business', 'core functionality',
      'main feature', 'high traffic', 'frequently used', 'public facing',
      'external', 'integration', 'third-party', 'data', 'database'
    ];
    
    // Combine all text for analysis
    const allText = `${given} ${when} ${then}`.toLowerCase();
    
    // Calculate risk score
    riskKeywords.forEach(keyword => {
      if (allText.includes(keyword.toLowerCase())) {
        riskScore += 1;
      }
    });
    
    // Calculate impact score
    impactKeywords.forEach(keyword => {
      if (allText.includes(keyword.toLowerCase())) {
        impactScore += 1;
      }
    });
    
    // Adjust scores based on scenario type
    if (type === 'edge_case') {
      riskScore += 1; // Edge cases inherently have higher risk
    } else if (type === 'happy_path') {
      impactScore += 1; // Happy paths often have higher impact if they fail
    }
    
    return {
      risk: Math.min(riskScore, 5), // Cap at 5
      impact: Math.min(impactScore, 5) // Cap at 5
    };
  };
  
  // Assign priority based on risk and impact scores
  const assignPriorityBasedOnRisk = ({ risk, impact }) => {
    const combinedScore = risk + impact;
    
    if (combinedScore >= 7) {
      return "Critical";
    } else if (combinedScore >= 5) {
      return "High";
    } else if (combinedScore >= 3) {
      return "Medium";
    } else {
      return "Low";
    }
  };
  
  // Generate preconditions based on scenario content
  const generatePreconditions = (description, type) => {
    const preconditions = [
      "System is available",
      "User has appropriate permissions"
    ];
    
    // Add type-specific preconditions
    if (type === 'happy_path') {
      preconditions.push("User is logged in to the system");
      
      // Check for specific features mentioned in the description
      if (description.toLowerCase().includes('dashboard')) {
        preconditions.push("User has access to the dashboard");
      }
      
      if (description.toLowerCase().includes('report')) {
        preconditions.push("Reporting module is enabled for the user");
      }
      
      if (description.toLowerCase().includes('payment') || description.toLowerCase().includes('checkout')) {
        preconditions.push("Payment gateway is configured and operational");
        preconditions.push("User has a valid payment method");
      }
    } else if (type === 'edge_case') {
      // For edge cases, add preconditions that set up the edge case
      if (description.toLowerCase().includes('invalid')) {
        preconditions.push("Test data for invalid inputs is prepared");
      }
      
      if (description.toLowerCase().includes('timeout')) {
        preconditions.push("System is configured to simulate timeout conditions");
      }
      
      if (description.toLowerCase().includes('error') || description.toLowerCase().includes('exception')) {
        preconditions.push("Error handling mechanisms are in place");
      }
    }
    
    return preconditions;
  };
  
  // Generate parameterized test case suggestions
  const generateParameterizedSuggestions = (given, when, isEdgeCase = false) => {
    const suggestions = [];
    
    // Common parameters for most test cases
    suggestions.push({
      parameter: "User Role",
      values: ["Admin", "Regular User", "Guest", "Manager"]
    });
    
    suggestions.push({
      parameter: "Browser/Device",
      values: ["Chrome", "Firefox", "Safari", "Mobile Device", "Tablet"]
    });
    
    // Add specific parameters based on content
    const combinedText = `${given} ${when}`.toLowerCase();
    
    if (combinedText.includes('login') || combinedText.includes('authentication')) {
      suggestions.push({
        parameter: "Credentials",
        values: ["Valid credentials", "Invalid username", "Invalid password", "Expired account"]
      });
    }
    
    if (combinedText.includes('form') || combinedText.includes('input') || combinedText.includes('field')) {
      suggestions.push({
        parameter: "Input Data",
        values: ["Valid data", "Boundary values", "Special characters", "Very long input"]
      });
    }
    
    if (combinedText.includes('search') || combinedText.includes('filter')) {
      suggestions.push({
        parameter: "Search Terms",
        values: ["Exact match", "Partial match", "No results", "Multiple results"]
      });
    }
    
    if (combinedText.includes('payment') || combinedText.includes('checkout')) {
      suggestions.push({
        parameter: "Payment Method",
        values: ["Credit Card", "PayPal", "Bank Transfer", "Gift Card"]
      });
    }
    
    // Add edge case specific parameters
    if (isEdgeCase) {
      suggestions.push({
        parameter: "Error Conditions",
        values: ["Network timeout", "Server error", "Validation failure", "Concurrent access"]
      });
    }
    
    return suggestions;
  };
  
  // Generate test suites based on modules/features
  const generateTestSuites = (scenarios) => {
    const suites = [];
    
    // Group by feature/module based on content analysis
    const featureGroups = {};
    
    // Extract features/modules from scenarios
    scenarios.forEach(scenario => {
      // Combine all text for analysis
      const allText = `${scenario.title} ${scenario.description} ${scenario.steps.map(s => s.text).join(' ')}`.toLowerCase();
      
      // Identify potential features/modules
      const features = identifyFeatures(allText);
      
      // Assign to primary feature group
      if (features.length > 0) {
        const primaryFeature = features[0];
        if (!featureGroups[primaryFeature]) {
          featureGroups[primaryFeature] = [];
        }
        featureGroups[primaryFeature].push(scenario);
      } else {
        // If no feature identified, add to "General" group
        if (!featureGroups["General"]) {
          featureGroups["General"] = [];
        }
        featureGroups["General"].push(scenario);
      }
    });
    
    // Create test suites from feature groups
    Object.keys(featureGroups).forEach(feature => {
      // Convert scenarios to test cases format expected by Test Suites page
      const testCases = featureGroups[feature].map(scenario => {
        // Determine status based on priority and type
        let status = 'Passed';
        if (scenario.priority === 'Critical' || scenario.priority === 'High') {
          // High priority items have a higher chance of failing in this mock
          status = Math.random() > 0.7 ? 'Passed' : 'Failed';
        } else if (scenario.type === 'edge_case') {
          // Edge cases have a higher chance of failing
          status = Math.random() > 0.6 ? 'Passed' : 'Failed';
        } else if (scenario.priority === 'Medium') {
          status = Math.random() > 0.8 ? 'Passed' : 'Failed';
        }
        
        // For some scenarios, mark them as pending
        if (Math.random() > 0.9) {
          status = 'Pending';
        }
        
        return {
          id: `tc-${scenario.id}`,
          name: scenario.title.split(':')[1]?.trim() || scenario.title,
          description: scenario.description,
          priority: scenario.priority,
          status: status,
          steps: scenario.steps.map(step => ({
            type: step.type,
            description: step.text
          })),
          expectedResult: scenario.expectedResult,
          preconditions: scenario.preconditions,
          type: scenario.type,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };
      });
      
      // Calculate pass rate based on test cases
      const passedCount = testCases.filter(tc => tc.status === 'Passed').length;
      const passRate = Math.round((passedCount / testCases.length) * 100);
      
      // Create suite with format matching Test Suites page
      suites.push({
        id: `suite-${suites.length + 1}`,
        name: feature,
        description: `Test cases for ${feature.toLowerCase()} functionality`,
        feature: feature,
        testCases: testCases,
        scenarioCount: testCases.length,
        passRate: passRate,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        automationStatus: calculateAutomationStatus(featureGroups[feature])
      });
    });
    
    return suites;
  };
  
  // Identify features/modules from text
  const identifyFeatures = (text) => {
    // Common features/modules in applications
    const commonFeatures = [
      "authentication", "login", "registration", "user management",
      "dashboard", "reporting", "analytics", "search",
      "payment", "checkout", "shopping cart", "product catalog",
      "profile", "settings", "configuration", "admin",
      "notification", "messaging", "chat", "communication",
      "file upload", "document management", "media",
      "integration", "api", "data import", "data export"
    ];
    
    // Find matches in the text
    const matches = [];
    commonFeatures.forEach(feature => {
      if (text.includes(feature.toLowerCase())) {
        matches.push(feature.charAt(0).toUpperCase() + feature.slice(1));
      }
    });
    
    // If no common features found, try to extract from the text
    if (matches.length === 0) {
      // Look for nouns that might be features
      const words = text.split(/\s+/);
      const potentialFeatures = words.filter(word =>
        word.length > 5 &&
        !word.match(/^(the|and|that|this|with|from|have|when|what|where|which|their|there|these|those|then|than)$/i)
      );
      
      if (potentialFeatures.length > 0) {
        // Use the first potential feature
        matches.push(potentialFeatures[0].charAt(0).toUpperCase() + potentialFeatures[0].slice(1));
      }
    }
    
    return matches;
  };
  
  // Calculate automation status for a group of scenarios
  const calculateAutomationStatus = (scenarios) => {
    const total = scenarios.length;
    const automatable = scenarios.filter(s => isAutomatable(s)).length;
    const percentage = Math.round((automatable / total) * 100);
    
    return {
      total,
      automatable,
      percentage,
      status: percentage >= 75 ? "High" : percentage >= 40 ? "Medium" : "Low"
    };
  };
  
  // Determine if a scenario is automatable
  const isAutomatable = (scenario) => {
    // Simple heuristic based on scenario type and content
    if (scenario.type === 'edge_case') {
      // Edge cases are often harder to automate
      return Math.random() > 0.3; // 70% chance of being automatable
    } else if (scenario.type === 'happy_path') {
      // Happy paths are usually easier to automate
      return Math.random() > 0.1; // 90% chance of being automatable
    } else {
      // BDD scenarios depend on complexity
      const complexity = scenario.steps.length + (scenario.parameterizedSuggestions?.length || 0);
      return complexity < 10; // Automatable if not too complex
    }
  };
  
  // Generate test plans based on epics/sprints
  const generateTestPlans = (testSuites, item, itemType) => {
    const plans = [];
    
    // If the item is an epic, create a test plan for it
    if (itemType === 'epic') {
      plans.push({
        id: `plan-${plans.length + 1}`,
        name: `Test Plan for ${item.key}: ${item.summary}`,
        description: `Comprehensive test plan for ${item.key} covering all identified test suites`,
        epicKey: item.key,
        epicSummary: item.summary,
        testSuites: testSuites,
        totalScenarios: testSuites.reduce((total, suite) => total + suite.scenarioCount, 0),
        automationStatus: calculateOverallAutomationStatus(testSuites),
        manualTestStrategy: generateManualTestStrategy(testSuites),
        automatedTestStrategy: generateAutomatedTestStrategy(testSuites)
      });
    } else {
      // For stories, create a smaller test plan
      plans.push({
        id: `plan-${plans.length + 1}`,
        name: `Test Plan for ${item.key}: ${item.summary}`,
        description: `Focused test plan for ${item.key} user story`,
        storyKey: item.key,
        storySummary: item.summary,
        epicKey: item.epicId,
        testSuites: testSuites,
        totalScenarios: testSuites.reduce((total, suite) => total + suite.scenarioCount, 0),
        automationStatus: calculateOverallAutomationStatus(testSuites),
        manualTestStrategy: generateManualTestStrategy(testSuites),
        automatedTestStrategy: generateAutomatedTestStrategy(testSuites)
      });
    }
    
    return plans;
  };
  
const handleRegenerateScenarios = async () => {
  try {
    setIsGenerating(true);
   
    const response = await axiosInstance.post(
      `/scenario/ai_regen_scenario_story?story_id=${item.dbId}`,
      {} 
    );

    console.log('Regenerate API Response:', response);

   const statusCode = response.status_code || 
                      response.data?.status_code || 
                      response.status;
    
    const message = response.data?.message || 
                   response.message || 
                   'Scenario generation started';

    if (statusCode === 201) {
      // toast.success(message || 'AI scenario generation started in background!');
    
      setTimeout(() => {
        generateTestScenarios();
      }, 5000);
          
     

      const storyId = item.dbId || item.id;
      const fetchResponse = await axiosInstance.get(
        `/scenario/?project_id=${projectId}&story_id=${storyId}`
      );
      
      if (fetchResponse.status === 200) {
       
        const mapScenarioType = (type) => {
      
          return type || 'Functional';
        };
        


        const parseRiskImpact = (impact) => {

          if (impact && typeof impact === 'object' && 'risk' in impact && 'impact' in impact) {
            return impact;
          }
       
          if (typeof impact === 'string' && impact.includes(',')) {
            const [risk, imp] = impact.split(',').map(Number);
            return { risk: isNaN(risk) ? 0 : risk, impact: isNaN(imp) ? 0 : imp };
          }

          if (typeof impact === 'string') {
            const levelMap = { 'low': 1, 'medium': 2, 'high': 3, 'critical': 4 };
            const val = levelMap[impact.toLowerCase()] ?? 2;
            return { risk: val, impact: val };
          }
     
          if (typeof impact === 'number') {
            return { risk: impact, impact: impact };
          }
      
          return { risk: 0, impact: 0 };
        };
        
        const mapParameterizedSuggestions = (suggestions) => {
        
          return suggestions || [];
        };


        const transformedScenarios = fetchResponse.data.scenarios.map(scenario => ({
          id: scenario.id,
          title: scenario.scenario_name,
          description: scenario.scenario_details?.scenario_summary || scenario.scenario_name,
          type: mapScenarioType(scenario.scenario_details?.scenario_type),
          preconditions: scenario.scenario_details?.preconditions || [],
          steps: scenario.scenario_details?.steps ? [
            { type: 'given', text: scenario.scenario_details.steps.given },
            { type: 'when', text: scenario.scenario_details.steps.when },
            { type: 'then', text: scenario.scenario_details.steps.then }
          ] : [],
          expectedResult: scenario.scenario_details?.expected_result || '',
          priority: scenario.scenario_details?.priority || 'Medium',
         

          riskImpact: parseRiskImpact(scenario.scenario_details?.risk_impact),
          estimatedTime: scenario.scenario_details?.estimated_time || '30 minutes',
          source: scenario.scenario_details?.source || 'AI Generated',
          parameterizedSuggestions: mapParameterizedSuggestions(scenario.scenario_details?.parameterized_test_suggestions)
        }));
     
      
        setGeneratedScenarios(transformedScenarios);
        
      
        if (onSave) {
          onSave(transformedScenarios, [], item, actualItemType);
        }
        
       
        setGenerationComplete(true);
        
     
        setSelectedScenarios(transformedScenarios.map(s => s.id));
        
        toast.success('Scenarios regenerated successfully!');
      }
    } else {
      throw new Error(message || 'Failed to start scenario generation');
    }
  } catch (error) {
    console.error('Error regenerating scenarios:', error);
    
 
    if (error.response) {
   
      const errorMessage = error.response.data?.message || 
                          error.response.data?.detail || 
                          error.response.statusText;
      toast.error(`Failed to regenerate scenarios: ${errorMessage}`);
    } else if (error.request) {
 
      toast.error('Failed to regenerate scenarios: No response from server');
    } else {
      
      toast.error(`Failed to regenerate scenarios: ${error.message}`);
    }
    
    setIsGenerating(false);
  }
};
  // Calculate overall automation status for all test suites
  const calculateOverallAutomationStatus = (testSuites) => {
    const totalScenarios = testSuites.reduce((total, suite) => total + suite.scenarioCount, 0);
    const totalAutomatable = testSuites.reduce((total, suite) => total + suite.automationStatus.automatable, 0);
    const percentage = Math.round((totalAutomatable / totalScenarios) * 100);
    
    return {
      totalScenarios,
      totalAutomatable,
      percentage,
      status: percentage >= 75 ? "High" : percentage >= 40 ? "Medium" : "Low"
    };
  };

  
  // Generate manual test strategy
  const generateManualTestStrategy = (testSuites) => {
    // Identify suites that need manual testing focus
    const manualFocusSuites = testSuites.filter(suite =>
      suite.automationStatus.percentage < 70
    );
    
    // Generate strategy based on manual focus suites
    return {
      overview: `Manual testing should focus on ${manualFocusSuites.length > 0 ?
        manualFocusSuites.map(s => s.feature).join(', ') :
        'edge cases and complex scenarios'}`,
      recommendations: [
        "Perform exploratory testing on complex user interactions",
        "Focus on usability and user experience aspects",
        "Test complex business logic scenarios manually",
        "Verify visual elements and layouts across different devices",
        "Conduct accessibility testing manually"
      ],
      estimatedEffort: `${Math.round(testSuites.reduce((total, suite) =>
        total + (suite.scenarioCount - suite.automationStatus.automatable) * 30, 0) / 60)} hours`
    };
  };
  
  // Generate automated test strategy
  const generateAutomatedTestStrategy = (testSuites) => {
    // Identify suites that are good candidates for automation
    const automationCandidates = testSuites.filter(suite =>
      suite.automationStatus.percentage >= 70
    );
    
    // Generate strategy based on automation candidates
    return {
      overview: `Automation should focus on ${automationCandidates.length > 0 ?
        automationCandidates.map(s => s.feature).join(', ') :
        'happy path scenarios and regression tests'}`,
      recommendations: [
        "Implement UI automation for critical user flows",
        "Create API test automation for backend functionality",
        "Set up automated regression test suite",
        "Implement data-driven tests for parameterized scenarios",
        "Configure CI/CD pipeline integration for automated tests"
      ],
      suggestedFrameworks: [
        "Selenium WebDriver for UI testing",
        "Cypress for modern web applications",
        "RestAssured for API testing",
        "JUnit/TestNG for unit and integration tests",
        "Cucumber for BDD implementation"
      ],
      estimatedEffort: `${Math.round(testSuites.reduce((total, suite) =>
        total + suite.automationStatus.automatable * 45, 0) / 60)} hours`
    };
  };

  // Handle scenario selection
  const handleScenarioSelection = (scenarioId) => {
    if (selectedScenarios.includes(scenarioId)) {
      setSelectedScenarios(selectedScenarios.filter(id => id !== scenarioId));
    } else {
      setSelectedScenarios([...selectedScenarios, scenarioId]);
    }
  };

  // Handle select all scenarios
  const handleSelectAll = () => {
    if (selectedScenarios.length === generatedScenarios.length) {
      setSelectedScenarios([]);
    } else {
      setSelectedScenarios(generatedScenarios.map(s => s.id));
    }
  };

  // Handle saving scenarios
 

  // Handle editing a scenario
 const handleEditScenario = (scenarioId) => {
  const scenario = generatedScenarios.find(s => s.id === scenarioId);
  setEditedScenarios(prev => ({
    ...prev,
    [scenarioId]: { ...scenario }
  }));
  setEditingScenarioId(scenarioId);
  // ensure the edited scenario is opened for better UX
  setOpenScenarioId(scenarioId);
};

// Toggle collapsible: open only one scenario at a time
const handleToggleScenarioOpen = (scenarioId) => {
  setOpenScenarioId(prev => (prev === scenarioId ? null : scenarioId));
};


  // Handle saving edited scenario
  const handleSaveEdit = () => {
    try {
      const updatedScenario = JSON.parse(editedContent);
      
      // Update the scenario in the generated scenarios
      const updatedScenarios = generatedScenarios.map(s =>
        s.id === editingScenario.id ? updatedScenario : s
      );
      
      setGeneratedScenarios(updatedScenarios);
      setEditingScenario(null);
    } catch (error) {
      toast.error('Invalid JSON format. Please check your edits.');
    }
  };

const handleCancelEdit = (scenarioId) => {

  setEditingScenarioId(null);
  setEditingScenario(null);
  

  setEditedScenarios(prev => {
    const newState = { ...prev };
    delete newState[scenarioId];
    return newState;
  });
};
const handleScenarioFieldChange = (scenarioId, field, value) => {
  setEditedScenarios(prev => ({
    ...prev,
    [scenarioId]: {
      ...prev[scenarioId],
      [field]: value
    }
  }));
};

const handleStepFieldChange = (scenarioId, stepIndex, field, value) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedSteps = [...updatedScenario.steps];
    updatedSteps[stepIndex] = {
      ...updatedSteps[stepIndex],
      [field]: value
    };
    updatedScenario.steps = updatedSteps;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const addStep = (scenarioId) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.steps = [
      ...updatedScenario.steps,
      { type: 'given', text: '' }
    ];
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const removeStep = (scenarioId, stepIndex) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.steps = updatedScenario.steps.filter((_, index) => index !== stepIndex);
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const addPrecondition = (scenarioId) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.preconditions = [
      ...updatedScenario.preconditions,
      ''
    ];
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const removePrecondition = (scenarioId, preconditionIndex) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.preconditions = updatedScenario.preconditions.filter((_, index) => index !== preconditionIndex);
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};
const handlePreconditionChange = (scenarioId, index, value) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedPreconditions = [...updatedScenario.preconditions];
    updatedPreconditions[index] = value;
    updatedScenario.preconditions = updatedPreconditions;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};
const handleSaveScenario = async (scenarioId) => {
  try {
  
    if (!editedScenarios[scenarioId]) {
      toast.error('No changes detected to save');
      return;
    }
    
    setSavingScenarioId(scenarioId);
    
    const editedScenario = editedScenarios[scenarioId];
    
    const scenarioData = {
      scenario_name: editedScenario.title,
      scenario_details: {
        scenario_summary: editedScenario.description,
        scenario_type: editedScenario.type,
        preconditions: editedScenario.preconditions.filter(p => p.trim() !== ''),
        steps: {
          given: editedScenario.steps.find(s => s.type === 'given')?.text || '',
          when: editedScenario.steps.find(s => s.type === 'when')?.text || '',
          then: editedScenario.steps.find(s => s.type === 'then')?.text || ''
        },
        expected_result: editedScenario.expectedResult,
        priority: editedScenario.priority,
        risk_impact: {
          risk: editedScenario.riskImpact?.risk ?? 0,
          impact: editedScenario.riskImpact?.impact ?? 0
        },
        estimated_time: editedScenario.estimatedTime
      }
    };


    const response = await axiosInstance.put(
      `/scenario/?scenario_id=${scenarioId}`,
      scenarioData
    );

    if (response.status_code === 200) {

      const updatedScenarios = generatedScenarios.map(scenario =>
        scenario.id === scenarioId ? { ...editedScenario } : scenario
      );
      
 
      setGeneratedScenarios(prevScenarios => 
        prevScenarios.map(scenario =>
          scenario.id === scenarioId ? { ...editedScenario } : scenario
        )
      );
      
   
      setEditingScenarioId(null);
      setEditingScenario(null);
 
      setEditedScenarios(prev => {
        const newState = { ...prev };
        delete newState[scenarioId];
        return newState;
      });
      
      toast.success('Scenario updated successfully!');
      
  
      setGenerationComplete(prev => !prev);
    }
  } catch (error) {
    console.error('Error saving scenario:', error);
    toast.error('Failed to update scenario');
  } finally {
    setSavingScenarioId(null);
  }
};

const handleRiskImpactChange = (scenarioId, field, value) => {
  setEditedScenarios(prev => ({
    ...prev,
    [scenarioId]: {
      ...prev[scenarioId],
      riskImpact: {
        ...prev[scenarioId].riskImpact,
        [field]: value
      }
    }
  }));
};

const handleParameterChange = (scenarioId, paramIndex, field, value) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedParams = [...updatedScenario.parameterizedSuggestions];
    updatedParams[paramIndex] = {
      ...updatedParams[paramIndex],
      [field]: value
    };
    updatedScenario.parameterizedSuggestions = updatedParams;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const handleParameterValueChange = (scenarioId, paramIndex, valueIndex, value) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedParams = [...updatedScenario.parameterizedSuggestions];
    const updatedValues = [...updatedParams[paramIndex].values];
    updatedValues[valueIndex] = value;
    updatedParams[paramIndex] = {
      ...updatedParams[paramIndex],
      values: updatedValues
    };
    updatedScenario.parameterizedSuggestions = updatedParams;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const addParameterSuggestion = (scenarioId) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.parameterizedSuggestions = [
      ...updatedScenario.parameterizedSuggestions,
      { parameter: 'New Parameter', values: ['Value 1'] }
    ];
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const removeParameterSuggestion = (scenarioId, paramIndex) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    updatedScenario.parameterizedSuggestions = updatedScenario.parameterizedSuggestions.filter((_, index) => index !== paramIndex);
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const addParameterValue = (scenarioId, paramIndex) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedParams = [...updatedScenario.parameterizedSuggestions];
    updatedParams[paramIndex] = {
      ...updatedParams[paramIndex],
      values: [...updatedParams[paramIndex].values, 'New Value']
    };
    updatedScenario.parameterizedSuggestions = updatedParams;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

const removeParameterValue = (scenarioId, paramIndex, valueIndex) => {
  setEditedScenarios(prev => {
    const updatedScenario = { ...prev[scenarioId] };
    const updatedParams = [...updatedScenario.parameterizedSuggestions];
    const updatedValues = updatedParams[paramIndex].values.filter((_, index) => index !== valueIndex);
    updatedParams[paramIndex] = {
      ...updatedParams[paramIndex],
      values: updatedValues
    };
    updatedScenario.parameterizedSuggestions = updatedParams;
    return {
      ...prev,
      [scenarioId]: updatedScenario
    };
  });
};

  // Render loading spinner during generation
  const renderLoadingSpinner = () => (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Generating test scenarios using AI...</p>
      <p className="loading-subtext">Analyzing requirements, extracting BDD patterns, and identifying edge cases...</p>
    </div>
  );

  // Render analysis results
  const renderAnalysisResults = () => {
  if (!analysisResults) return null;
  
  return (
    <div className="analysis-results">
      <h3>Analysis Results</h3>
      <div className="analysis-stats">
        <div className="analysis-stat">
          <span className="stat-label">BDD Patterns</span>
          <span className="stat-value">{analysisResults.bdd_patterns || analysisResults.bddPatterns || 0}</span>
        </div>
        <div className="analysis-stat">
          <span className="stat-label">Happy Paths</span>
          <span className="stat-value">{analysisResults.happy_paths || analysisResults.happyPaths || 0}</span>
        </div>
        <div className="analysis-stat">
          <span className="stat-label">Edge Cases</span>
          <span className="stat-value">{analysisResults.edge_cases || analysisResults.edgeCases || 0}</span>
        </div>
      </div>
      
      {/* Display additional analysis data if available from API */}
      {analysisResults.summary && (
        <div className="analysis-summary">
          <h4>Summary</h4>
          <p>{analysisResults.summary}</p>
        </div>
      )}
      
      {analysisResults.key_findings && (
        <div className="key-findings">
          <h4>Key Findings</h4>
          <ul>
            {analysisResults.key_findings.map((finding, index) => (
              <li key={index}>{finding}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
  // Render scenario card


const renderScenario = (scenario) => {
  const isEditing = editingScenarioId === scenario.id;
  const editedScenario = editedScenarios[scenario.id] || scenario;

  return (
    <div
      key={scenario.id}
      className={`test-case-card ${selectedScenarios.includes(scenario.id) ? 'selected' : ''} ${scenario.type}-card ${isEditing ? 'editing-mode' : ''} ${openScenarioId === scenario.id ? 'open' : 'collapsed'}`}
    >
      <div className="test-case-header" onClick={() => !isEditing && handleToggleScenarioOpen(scenario.id)} style={{cursor: isEditing ? 'default' : 'pointer'}}>
        <div className="test-case-selection">
          <input
            type="checkbox"
            checked={selectedScenarios.includes(scenario.id)}
            onChange={() => handleScenarioSelection(scenario.id)}
            onClick={(e) => e.stopPropagation()}
            id={`scenario-${scenario.id}`}
            disabled={isEditing}
          />
          
          {isEditing ? (
            <input
              type="text"
              value={editedScenario.title}
              onChange={(e) => handleScenarioFieldChange(scenario.id, 'title', e.target.value)}
              className="edit-title-input"
              placeholder="Scenario title"
            />
          ) : (
            <label htmlFor={`scenario-${scenario.id}`} className="test-case-title">
              {scenario.title}
            </label>
          )}
        </div>
        
        <div className="test-case-actions">
          {isEditing ? (
            <>
              <button
                className="save-test-case-btn"
                onClick={(e) => { e.stopPropagation(); handleSaveScenario(scenario.id); }}
                title="Save changes"
                disabled={savingScenarioId === scenario.id}
              >
                {savingScenarioId === scenario.id ? (
                  <div className="btn-spinner-small"></div>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                    <polyline points="17 21 17 13 7 13 7 21"></polyline>
                    <polyline points="7 3 7 8 15 8"></polyline>
                  </svg>
                )}
              </button>
              <button
                className="cancel-edit-btn"
                onClick={(e) => { e.stopPropagation(); handleCancelEdit(scenario.id); }}
                title="Cancel editing"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </>
          ) : (
            <>
              <button
                className="edit-test-case-btn"
                onClick={(e) => { e.stopPropagation(); handleEditScenario(scenario.id); }}
                title="Edit scenario"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
              </button>
              <button
                className='delete-test-case-btn'
                title='Delete scenario'
                onClick={(e) => { e.stopPropagation(); requestDeleteScenario(scenario.id); }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
            </>
          )}
        </div>
      </div>
      
      {/* Collapse/expand: only render details when this scenario is open or in editing mode */}
      {openScenarioId === scenario.id || isEditing ? (
        <div className="test-case-meta">
        {isEditing ? (
          <div className="editable-meta">
            <div className="meta-field">
              <label>Type:</label>
              <select
                value={editedScenario.type}
                onChange={(e) => handleScenarioFieldChange(scenario.id, 'type', e.target.value)}
                className="edit-type-select"
              >
                <option value="bdd">BDD</option>
                <option value="happy_path">Happy Path</option>
                <option value="edge_case">Edge Case</option>
              </select>
            </div>
            
            <div className="meta-field">
              <label>Priority:</label>
              <select
                value={editedScenario.priority}
                onChange={(e) => handleScenarioFieldChange(scenario.id, 'priority', e.target.value)}
                className="edit-priority-select"
              >
                <option value="Critical">Critical</option>
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            
            <div className="meta-field">
              <label>Risk:</label>
              <select
                value={editedScenario.riskImpact.risk}
                onChange={(e) => handleRiskImpactChange(scenario.id, 'risk', parseInt(e.target.value))}
                className="edit-risk-select"
              >
                {[1, 2, 3, 4, 5].map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
            </div>
            
            <div className="meta-field">
              <label>Impact:</label>
              <select
                value={editedScenario.riskImpact.impact}
                onChange={(e) => handleRiskImpactChange(scenario.id, 'impact', parseInt(e.target.value))}
                className="edit-impact-select"
              >
                {[1, 2, 3, 4, 5].map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
            </div>
            
            <div className="meta-field">
              <label>Time:</label>
              <input
                type="text"
                value={editedScenario.estimatedTime}
                onChange={(e) => handleScenarioFieldChange(scenario.id, 'estimatedTime', e.target.value)}
                className="edit-time-input"
                placeholder="30 minutes"
              />
            </div>
          </div>
        ) : (
        
          <>
            <span className={`scenario-type-badge ${scenario.type}`}>
              {scenario.type === 'bdd' ? 'BDD' :
               scenario.type === 'happy_path' ? 'Happy Path' :
               'Edge Case'}
            </span>
            <span className={`priority-badge priority-${scenario.priority.toLowerCase()}`}>
              {scenario.priority}
            </span>
            <span className="risk-impact-badge" title={`Risk: ${scenario.riskImpact.risk}/5, Impact: ${scenario.riskImpact.impact}/5`}>
              R/I: {scenario.riskImpact.risk}/{scenario.riskImpact.impact}
            </span>
            <span className="time-estimate">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              {scenario.estimatedTime}
            </span>
          </>
        )}
      </div>
      ) : (
        <div className="collapsed-summary">
          <span className="scenario-type-badge small">{scenario.type === 'bdd' ? 'BDD' : scenario.type === 'happy_path' ? 'Happy' : 'Edge'}</span>
          <span className={`priority-badge small priority-${scenario.priority.toLowerCase()}`}>{scenario.priority}</span>
          <span className="time-estimate small">{scenario.estimatedTime}</span>
          <div className="short-description">{scenario.description && scenario.description.length > 120 ? scenario.description.substring(0, 117) + '...' : scenario.description}</div>
        </div>
      )}
      

      <div className="test-case-description">
        {isEditing ? (
          <textarea
            value={editedScenario.description}
            onChange={(e) => handleScenarioFieldChange(scenario.id, 'description', e.target.value)}
            className="edit-description-textarea"
            placeholder="Scenario description"
            rows="2"
          />
        ) : (
          scenario.description
        )}
      </div>
      

      <div className="test-case-content">
        <div className="test-case-section">
          <h4>Preconditions:</h4>
          {isEditing ? (
            <div className="editable-preconditions">
              {editedScenario.preconditions.map((precondition, index) => (
                <div key={index} className="editable-precondition-item">
                  <textarea
                    value={precondition}
                    onChange={(e) => handlePreconditionChange(scenario.id, index, e.target.value)}
                    className="edit-precondition-textarea"
                    placeholder="Enter precondition..."
                    rows="1"
                  />
                  <button
                    type="button"
                    onClick={() => removePrecondition(scenario.id, index)}
                    className="remove-precondition-btn"
                    title="Remove precondition"
                  >
                    ×
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => addPrecondition(scenario.id)}
                className="add-precondition-btn"
              >
                + Add Precondition
              </button>
            </div>
          ) : (
            <ul className="preconditions-list">
              {scenario.preconditions.map((precondition, index) => (
                <li key={index}>{precondition}</li>
              ))}
            </ul>
          )}
        </div>
       <div className="test-case-section">
          <h4>Steps:</h4>
          {isEditing ? (
            <div className="editable-steps">
              {editedScenario.steps.map((step, index) => (
                <div key={index} className="editable-step">
                  <select
                    value={step.type}
                    onChange={(e) => handleStepFieldChange(scenario.id, index, 'type', e.target.value)}
                    className="step-type-select"
                  >
                    <option value="given">Given</option>
                    <option value="when">When</option>
                    <option value="then">Then</option>
                  </select>
                  <textarea
                    value={step.text}
                    onChange={(e) => handleStepFieldChange(scenario.id, index, 'text', e.target.value)}
                    className="step-text-textarea"
                    placeholder={`${step.type}...`}
                    rows="1"
                  />
                  <button
                    type="button"
                    onClick={() => removeStep(scenario.id, index)}
                    className="remove-step-btn"
                    title="Remove step"
                  >
                    ×
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={() => addStep(scenario.id)}
                className="add-step-btn"
              >
                + Add Step
              </button>
            </div>
          ) : (
            <div className="bdd-steps">
              {scenario.steps.map((step, index) => (
                <div key={index} className={`bdd-step ${step.type}`}>
                  <span className="step-keyword">{step.type.charAt(0).toUpperCase() + step.type.slice(1)}</span>
                  <span className="step-text">{step.text}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        
  
        <div className="test-case-section">
          <h4>Expected Result:</h4>
          {isEditing ? (
            <textarea
              value={editedScenario.expectedResult}
              onChange={(e) => handleScenarioFieldChange(scenario.id, 'expectedResult', e.target.value)}
              className="edit-expected-result-textarea"
              placeholder="Expected result"
              rows="2"
            />
          ) : (
            <p className="expected-result">{scenario.expectedResult}</p>
          )}
        </div>
        
        <div className="test-case-section">
          <h4>Parameterized Test Suggestions:</h4>
          {isEditing ? (
            <div className="editable-parameterized-suggestions">
              {editedScenario.parameterizedSuggestions.map((suggestion, index) => (
                <div key={index} className="editable-parameter-group">
                  <div className="parameter-header">
                    <input
                      type="text"
                      value={suggestion.parameter}
                      onChange={(e) => handleParameterChange(scenario.id, index, 'parameter', e.target.value)}
                      className="parameter-name-input"
                      placeholder="Parameter name"
                    />
                    <button
                      type="button"
                      onClick={() => removeParameterSuggestion(scenario.id, index)}
                      className="remove-parameter-btn"
                      title="Remove parameter"
                    >
                      ×
                    </button>
                  </div>
                  <div className="parameter-values-editable">
                    {suggestion.values.map((value, vIndex) => (
                      <div key={vIndex} className="parameter-value-item">
                        <input
                          type="text"
                          value={value}
                          onChange={(e) => handleParameterValueChange(scenario.id, index, vIndex, e.target.value)}
                          className="parameter-value-input"
                          placeholder="Parameter value"
                        />
                        <button
                          type="button"
                          onClick={() => removeParameterValue(scenario.id, index, vIndex)}
                          className="remove-value-btn"
                          title="Remove value"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => addParameterValue(scenario.id, index)}
                      className="add-value-btn"
                    >
                      + Add Value
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                onClick={() => addParameterSuggestion(scenario.id)}
                className="add-parameter-btn"
              >
                + Add Parameter Group
              </button>
            </div>
          ) : (
            <div className="parameterized-suggestions">
              {scenario.parameterizedSuggestions.map((suggestion, index) => (
                <div key={index} className="parameter-group">
                  <div className="parameter-name">{suggestion.parameter}:</div>
                  <div className="parameter-values">
                    {suggestion.values.map((value, vIndex) => (
                      <span key={vIndex} className="parameter-value">{value}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
   
        <div className="test-case-section">
          <h4>Source:</h4>
          {isEditing ? (
            <input
              type="text"
              value={editedScenario.source || ''}
              onChange={(e) => handleScenarioFieldChange(scenario.id, 'source', e.target.value)}
              className="edit-source-input"
              placeholder="Source information"
            />
          ) : (
            <p>{scenario.source}</p>
          )}
        </div>
      </div>
    </div>
  );
};

  // Render scenario editor
  const renderScenarioEditor = () => (
    <div className="test-case-editor-overlay">
      <div className="test-case-editor">
        <div className="editor-header">
          <h3>Edit Scenario</h3>
          <button className="close-editor-btn" onClick={handleCancelEdit}>×</button>
        </div>
        <div className="editor-content">
          <textarea
            value={editedContent}
            onChange={(e) => setEditedContent(e.target.value)}
            className="editor-textarea"
          />
        </div>
        <div className="editor-footer">
          <button className="cancel-btn" onClick={handleCancelEdit}>Cancel</button>
          <button className="save-btn" onClick={handleSaveEdit}>Save Changes</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ai-testcase-generator-overlay rt-scenario-page">
      <div className="ai-testcase-generator-container rt-scenario-panel">
        <header className="rt-scenario-chrome">
          <div className="rt-scenario-chrome__nav">
            <button
              type="button"
              className="rt-btn rt-btn--secondary rt-btn--sm"
              onClick={onClose}
              title="Back to Jira items"
            >
              ← Back to Jira
            </button>
            <span className="rt-scenario-chrome__crumb">
              Requirements / Jira / Scenarios
            </span>
          </div>
          <div className="rt-scenario-chrome__title-row">
            <div>
              <div className="rt-scenario-chrome__badges">
                <span className={`rt-badge ${actualItemType === 'epic' ? 'rt-badge--info' : 'rt-badge--neutral'}`}>
                  {actualItemType === 'epic' ? 'Epic' : 'Story'}
                </span>
                <span className="rt-badge rt-badge--info">AI Scenarios</span>
              </div>
              <h2 className="rt-scenario-chrome__title">
                {actualItemType === 'epic'
                  ? `${item.key}: ${item.summary}`
                  : `${item.epicKey || item.epicId || ''} → ${item.key}: ${item.summary}`}
              </h2>
              {actualItemType === 'story' && item.epicKey && (
                <p className="rt-scenario-chrome__meta">Epic: {item.epicKey}</p>
              )}
            </div>
          </div>
          {item.description ? (
            <p className="rt-scenario-chrome__desc">{item.description}</p>
          ) : null}
        </header>
        
        <div className="generator-content">
          {isGenerating ? (
            renderLoadingSpinner()
          ) : (
            <>
              {analysisResults && renderAnalysisResults()}
              
              <div className="view-toggle">
              </div>
              
              {!showTestPlanView ? (
                <div className="test-cases-container">
                  <div className="test-cases-header rt-scenario-toolbar">
                    <div className="test-cases-title">
                      <h3>Generated Test Scenarios ({generatedScenarios.length})</h3>
                      {generationComplete && (
                        <button
                          className="rt-btn rt-btn--secondary rt-btn--sm"
                             onClick={handleRegenerateScenarios}
                          
                          title="Regenerate test scenarios"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M23 4v6h-6"></path>
                            <path d="M1 20v-6h6"></path>
                            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"></path>
                            <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"></path>
                          </svg>
                          Regenerate
                        </button>
                      )}
        
   
  
  {/* Updated button logic */}
  {caseGenerated ? (
    <button
      className="rt-btn rt-btn--secondary rt-btn--sm"
      onClick={handleViewTestCases}
      title="View Generated Test Cases"
      disabled={generatingTestCases}
    >
      {generatingTestCases ? (
        <>
          <div className="btn-spinner"></div>
          Loading...
        </>
      ) : (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          View Test Cases
        </>
      )}
    </button>
  ) : (
    <button
      className="rt-btn rt-btn--primary rt-btn--sm"
      onClick={handleGenerateTestCases}
      title="Generate AI Test Cases"
      disabled={generatingTestCases}
    >
      {generatingTestCases ? (
        <>
          <div className="btn-spinner"></div>
          Generating...
        </>
      ) : (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>
          </svg>
          Generate Test Cases
        </>
      )}
    </button>
  )}
                    </div>
                    
                    {generatedScenarios.length > 0 && (
                      <div className="test-cases-actions">
                        <div className="select-all-container">
                          <input
                            type="checkbox"
                            id="select-all"
                            checked={selectedScenarios.length === generatedScenarios.length && generatedScenarios.length > 0}
                            onChange={handleSelectAll}
                          />
                          <label htmlFor="select-all">Select All</label>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="test-cases-list">
                    {generatedScenarios.length > 0 ? (
                      generatedScenarios.map(scenario => renderScenario(scenario))
                    ) : (
                      <div className="no-test-cases rt-scenario-empty">
                        <p>No test scenarios have been generated yet.</p>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
              
              {showTestPlanView && (
                <div className="test-plans-view">
                  <div className="test-strategy-toggle">
                    <button
                      className={`strategy-toggle-btn ${activeTestStrategy === 'both' ? 'active' : ''}`}
                      onClick={() => setActiveTestStrategy('both')}
                    >
                      Both
                    </button>
                    <button
                      className={`strategy-toggle-btn ${activeTestStrategy === 'manual' ? 'active' : ''}`}
                      onClick={() => setActiveTestStrategy('manual')}
                    >
                      Manual
                    </button>
                    <button
                      className={`strategy-toggle-btn ${activeTestStrategy === 'automated' ? 'active' : ''}`}
                      onClick={() => setActiveTestStrategy('automated')}
                    >
                      Automated
                    </button>
                  </div>
                  
                  {testPlans.map(plan => (
                    <div key={plan.id} className="test-plan-card">
                      <div className="test-plan-header">
                        <h3>{plan.name}</h3>
                        <div className="test-plan-meta">
                          <span className="test-plan-scenarios">
                            {plan.totalScenarios} Scenarios
                          </span>
                          <span className="automation-badge">
                            Automation: {plan.automationStatus.percentage}% ({plan.automationStatus.status})
                          </span>
                        </div>
                      </div>
                      
                      <div className="test-plan-description">
                        {plan.description}
                      </div>
                      
                      {(activeTestStrategy === 'manual' || activeTestStrategy === 'both') && (
                        <div className="test-strategy-section">
                          <h4>Manual Test Strategy</h4>
                          <div className="strategy-overview">
                            {plan.manualTestStrategy.overview}
                          </div>
                          <h5>Recommendations:</h5>
                          <ul className="strategy-recommendations">
                            {plan.manualTestStrategy.recommendations.map((rec, index) => (
                              <li key={index}>{rec}</li>
                            ))}
                          </ul>
                          <div className="strategy-effort">
                            Estimated Effort: {plan.manualTestStrategy.estimatedEffort}
                          </div>
                        </div>
                      )}
                      
                      {(activeTestStrategy === 'automated' || activeTestStrategy === 'both') && (
                        <div className="test-strategy-section">
                          <h4>Automated Test Strategy</h4>
                          <div className="strategy-overview">
                            {plan.automatedTestStrategy.overview}
                          </div>
                          <h5>Recommendations:</h5>
                          <ul className="strategy-recommendations">
                            {plan.automatedTestStrategy.recommendations.map((rec, index) => (
                              <li key={index}>{rec}</li>
                            ))}
                          </ul>
                          <h5>Suggested Frameworks:</h5>
                          <div className="suggested-frameworks">
                            {plan.automatedTestStrategy.suggestedFrameworks.map((framework, index) => (
                              <span key={index} className="framework-badge">{framework}</span>
                            ))}
                          </div>
                          <div className="strategy-effort">
                            Estimated Effort: {plan.automatedTestStrategy.estimatedEffort}
                          </div>
                        </div>
                      )}
                      
                      <div className="test-suites-section">
                        <h4>Test Suites</h4>
                        <div className="test-suites-list">
                          {plan.testSuites.map(suite => (
                            <div
                              key={suite.id}
                              className="test-suite-card clickable"
                              onClick={() => onNavigateToTestSuite && onNavigateToTestSuite(suite.id, suite.name, suite)}
                              title="Click to view this test suite"
                            >
                              <div className="test-suite-header">
                                <h5>{suite.name}</h5>
                                <span className="suite-scenario-count">
                                  {suite.scenarioCount} Scenarios
                                </span>
                              </div>
                              <div className="test-suite-description">
                                {suite.description}
                              </div>
                              <div className="test-suite-meta">
                                <span className="automation-badge small">
                                  Automation: {suite.automationStatus.percentage}% ({suite.automationStatus.status})
                                </span>
                                <span className="view-link">View Test Suite →</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      
      {editingScenario && renderScenarioEditor()}
      {showTestCasesModal && (
  <TestCasesModal
    testCasesData={generatedTestCases}
    onClose={() => setShowTestCasesModal(false)}
    onViewTestCases={handleViewTestCases}
     title= {`Generated Test Cases for ${item.key}`}
projectId={projectId}
    storyId={item.dbId || item.id}
  />
)}
      <DeleteConfirmationModal
        isOpen={showDeleteConfirm}
        itemName={scenarioToDelete?.title}
        itemType="scenario"
        onCancel={cancelDeleteScenario}
        onConfirm={confirmDeleteScenario}
        isProcessing={isDeletingScenario}
      />
    </div>
  );
};

export default AutomatedTestScenarioGenerator;